<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45">
            MIRADAS AL <br>
            ANTIGUO PERÚ <br>
            A INICIOS DEL SIGLO XX <br>
            <span style="line-height: 100%;" class="fontMS300">
            </span>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio15/miradas-al-antiguo-peru">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio15/miradas-al-antiguo-peru">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio15/miradas-al-antiguo-peru">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img width="100%" src="/assets/images/micrositio/micrositio15/ET03_MS010_ANTIGUO_img001.jpg">
</section>

<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-center  font-24">
                    EL CONOCIMIENTO SOBRE EL ANTIGUO PERÚ PROVIENE PRINCIPALMENTE DE LAS CRÓNICAS Y OTROS TEXTOS
                    COLONIALES QUE EN SU MAYORÍA FUERON ESCRITOS POR LOS CONQUISTADORES. EN LAS PRIMERAS DÉCADAS DEL
                    SIGLO XX, EMERGEN DISCIPLINAS ACADÉMICAS Y CIENTÍFICAS COMO LA ARQUEOLOGÍA, LA ANTROPOLOGÍA Y LA
                    ETNOHISTORIA QUE ELABORAN UNA NUEVA MIRADA <br> SOBRE NUESTRO PASADO PREHISPÁNICO A PARTIR DE
                    DIFERENTES <br>FUENTES ESCRITAS, ORALES Y MATERIALES.
                    <br>
                </p>
                <p class="fontMS100 text-justify  font-24 text-gris">
                    <br>
                    La colección del antropólogo Paul Rivet en la Biblioteca Nacional del Perú documenta este cambio.
                    A partir de una selección de tesis, ponencias y libros de este archivo, se puede apreciar la
                    importancia de la interdisciplinariedad para la transformación del estudio del antiguo Perú. El
                    trabajo interdisciplinario es clave, los restos arqueológicos (textiles, monumentos, cerámica,
                    restos humanos), la cultura inmaterial (mitos, leyendas, música), todo tipo de documento histórico y
                    la valoración de la cultura viva popular andina se complementan. Poco a poco se va forjando una
                    visión más completa y compleja del pasado. La intención no es simplemente enorgullecerse de las
                    grandes civilizaciones de antaño, sino aprender de estas a manejar mejor las condiciones materiales
                    y naturales de nuestro país, y a reconocer y respetar nuestra diversidad cultural.
                    <br>
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco_L">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p>
                    <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco_PR">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS300 text-center colorPrincipal font-40">
                            LA COLECCIÓN <br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    PAUL RIVET
                </p>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 5%;margin-bottom: 10%;" width="100%"
                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                </div>
                <div class="row mt-5">
                    <div class="col-sm-5">
                        <p class="fontMS500 font-24 p2">
                            LA BIBLIOTECA NACIONAL ADQUIERE LA COLECCIÓN DEL RECONOCIDO ETNÓLOGO Y AMERICANISTA FRANCÉS
                            PAUL RIVET EN 1957. CONTIENE MÁS DE MIL DOCUMENTOS RELACIONADOS CON EL ESTUDIO DEL QUECHUA,
                            EL AYMARA Y LAS CULTURAS INDÍGENAS.
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-7 bottom_cel ">
                        <p class="text-justify fontMS100 font-24 p2_1">
                            Esta amplia colección incluye gramáticas y catecismos del periodo virreinal, libros
                            bilingües y trilingües que hoy forman parte del patrimonio cultural del mundo. También hay
                            partituras, cartillas pedagógicas, poesía, obras de teatro y novelas, estudios lingüísticos,
                            históricos y arqueológicos. Estos documentos manifiestan la reivindicación de las culturas
                            indígenas desde el arte, la literatura y las ciencias sociales en el siglo XX. Nos invitan a
                            reflexionar sobre la identidad nacional. Aunque su lectura, en algunos casos, no sea fácil,
                            estos documentos resaltan desafíos y tensiones que siguen vigentes en nuestro país
                            pluricultural y plurilingüe.
                        </p>
                    </div>

                    <div class="c100">
                        <p class="text-justify fontMS100 font-24 p2_1">
                            Esta amplia colección incluye gramáticas y catecismos del periodo virreinal, libros
                            bilingües y trilingües que hoy forman parte del patrimonio cultural del mundo. También hay
                            partituras, cartillas pedagógicas, poesía, obras de teatro y novelas, estudios lingüísticos,
                            históricos y arqueológicos. Estos documentos manifiestan la reivindicación de las culturas
                            indígenas desde el arte, la literatura y las ciencias sociales en el siglo XX. Nos invitan a
                            reflexionar sobre la identidad nacional. Aunque su lectura, en algunos casos, no sea fácil,
                            estos documentos resaltan desafíos y tensiones que siguen vigentes en nuestro país
                            pluricultural y plurilingüe.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris_PR">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-5">
                <p class="imgPaulRivet text-right">
                    <img class="imgNP" width="70%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img002.jpg">
                    <br>
                    <span class="fontMS100Italic t5">Fuente: Biblioteca Nacional Digital de Chile</span>
                </p>
            </div>
            <div class="col-sm-7 bottom_cel">
                <p style="line-height: 100%;" class="fontMS300 font-24">
                    <span class="font-40 fontMS500">PAUL RIVET</span><br> (Francia, 1876-1959)
                </p>
                <p class="font-24 text-gris text-justify">
                    <br>
                    Llega a Sudamérica por primera vez en 1901 como parte de la Segunda Misión Geodésica. Durante varios
                    años documenta la historia natural de Ecuador y termina rechazando las prácticas imperantes de la
                    antropología en ese momento. En lugar de medir y clasificar a los seres humanos, Rivet promueve la
                    etnología como una manera de apreciar la igualdad de las sociedades. Dedica los últimos años de su
                    vida al estudio de la diversidad lingüística en la región andina. Antes de fallecer traslada parte
                    de su colección a la Biblioteca Nacional del Perú.
                </p>
            </div>
            <div class="c100">
                <p style="line-height: 100%;" class="fontMS300 font-24">
                    <span class="font-40 fontMS500">PAUL RIVET</span><br> (Francia, 1876-1959)
                </p>
                <p class="text-justify fontMS100 font-24 p2_1">
                    Llega a Sudamérica por primera vez en 1901 como parte de la Segunda Misión Geodésica. Durante varios
                    años documenta la historia natural de Ecuador y termina rechazando las prácticas imperantes de la
                    antropología en ese momento. En lugar de medir y clasificar a los seres humanos, Rivet promueve la
                    etnología como una manera de apreciar la igualdad de las sociedades. Dedica los últimos años de su
                    vida al estudio de la diversidad lingüística en la región andina. Antes de fallecer traslada parte
                    de su colección a la Biblioteca Nacional del Perú.
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoMarron">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LOS INICIOS DE <br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS700 text-center colorPrincipal font-40">
                    LA ARQUEOLOGÍA PERUANA
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                </div>
                <p class="fontMS500 text-center text-white font-24">
                    <br>
                    EL PERÚ ES UN PAÍS QUE TIENE UN PATRIMONIO CULTURAL ARQUEOLÓGICO MILENARIO. A MEDIADOS DEL SIGLO XIX
                    SE INICIA EL ESTUDIO CIENTÍFICO DE LOS RESTOS ARQUEOLÓGICOS DE ESTAS GRANDES CIVILIZACIONES, PERO NO
                    ES HASTA COMIENZOS DEL SIGLO XX QUE SE INAUGURA LA ARQUEOLOGÍA PERUANA. GRACIAS A LOS ESFUERZOS
                    INCANSABLES DE JULIO C. TELLO, SE LOGRA ESTABLECER UNA APROXIMACIÓN REFLEXIVA, SISTEMÁTICA E
                    INTERDISCIPLINARIA HACIA EL REGISTRO MATERIAL DEL ANTIGUO PERÚ.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="font-24 text-white">
                            En su tesis de bachiller,
                            <span class="fontMS100Italic">La antigüedad de la sífilis en el Perú</span>
                            , ya se puede vislumbrar la metodología innovadora del joven arqueólogo. En este estudio,
                            Tello desarrolla cuatro líneas de investigación complementarias para corroborar su
                            hipótesis. Estudia vocabulario médico en quechua, infiere las normas sexuales de la época a
                            través de documentos coloniales, y verifica la presencia de lesiones tanto en la cerámica
                            precolombina como en los restos óseos. Así, fomenta la interdisciplinariedad en la
                            arqueología e impulsa la creación de nuevas disciplinas como la antropología médica.
                            <br>
                        </p>
                    </div>
                </div>
                <br><br>
                <div class="row menuWebPhone">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-8">
                        <div class="row">
                            <div class="col-sm-4">
                                <p class="text-center">
                                    <img class="imgArque"
                                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img003.jpg"><br>
                                    <span class="fontMS100Italic text-white">
                                        Fuente: MNAAHP.
                                    </span>
                                </p>
                            </div>
                            <div class="col-sm-4">
                                <p class="text-center">
                                    <a href="https://hdl.handle.net/20.500.14428/40745" target="_blank">
                                        <img class="imgArque"
                                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img009.jpg">
                                    </a>
                                </p>
                            </div>
                            <div class="col-sm-4">
                                <p class="text-center">
                                    <a href="https://hdl.handle.net/20.500.14428/36661" target="_blank">
                                        <img class="imgArque"
                                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img008.jpg">
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2"></div>
                    <div class="col-sm-2"></div>
                    <div class="col-sm-4">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/36699" style="color: inherit;" target="_blank">
                                <img class="imgArque"
                                    src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img010.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="text-center">

                            <a href="https://hdl.handle.net/20.500.14428/24350" style="color: inherit;" target="_blank">
                                <img class="imgArque"
                                    src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img011.jpg">
                            </a>
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-2"></div>
                    <div class="col-sm-3">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/36913" style="color: inherit;" target="_blank">
                                <img class="imgArque"
                                    src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img004.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <p class="text-center">
                            <a href="http://hdl.handle.net/20.500.14428/79183" style="color: inherit;" target="_blank">
                                <img class="imgArque"
                                    src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img005.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <p class="text-center">
                            <a href="http://hdl.handle.net/20.500.14428/79188" style="color: inherit;" target="_blank">
                                <img class="imgArque"
                                    src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img006.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <p class="text-center">
                            <a href="http://hdl.handle.net/20.500.14428/79161" style="color: inherit;" target="_blank">
                                <img class="imgArque"
                                    src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img007.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-12">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-sm-2">
                                </div>
                                <div class="col-sm-8">
                                    <p>
                                        <br><br>
                                    </p>
                                    <iframe width="100%" height="475" src="https://www.youtube.com/embed/iiKu-CEwauY"
                                        title="YouTube video player" frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                    <p class="text-center">
                                        <span class="fontMS100Italic text-white">
                                            En el Museo de Arqueología y Antropología. Noticiarios Peruanos de la década
                                            de 1940. Película grabada en cintas de nitrato de 35 mm y digitalizada en la
                                            Biblioteca Digital BNP.
                                        </span>
                                    </p>
                                </div>
                                <div class="col-sm-2">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 tab3">
                            <p class="text-center">
                                <img class="imgArque"
                                    src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img003.jpg"><br>
                                <span class="fontMS100Italic text-white">
                                    Fuente: MNAAHP.
                                </span>
                            </p>
                        </div>
                        <div class="col-sm-6 tab3">
                            <p class="text-center">
                                <a href="https://hdl.handle.net/20.500.14428/40745" target="_blank">
                                    <img class="imgArque"
                                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img009.jpg">
                                </a>
                            </p>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 tab3">
                            <p class="text-center">
                                <a href="https://hdl.handle.net/20.500.14428/36661" target="_blank">
                                    <img class="imgArque"
                                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img008.jpg">
                                </a>
                            </p>
                        </div>
                        <div class="col-sm-6 tab3">
                            <p class="text-center">
                                <a href="https://hdl.handle.net/20.500.14428/36699" style="color: inherit;" target="_blank">
                                    <img class="imgArque"
                                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img010.jpg">
                                </a>
                            </p>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 tab3">
                            <p class="text-center">
                                <a href="https://hdl.handle.net/20.500.14428/24350" style="color: inherit;" target="_blank">
                                    <img class="imgArque"
                                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img011.jpg">
                                </a>
                                <br><br>
                            </p>
                        </div>
                        <div class="col-sm-6 tab3">
                            <p class="text-center">
                                <a href="https://hdl.handle.net/20.500.14428/36913" style="color: inherit;" target="_blank">
                                    <img class="imgArque"
                                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img004.jpg">
                                </a>
                            </p>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 tab3">
                            <p class="text-center">
                                <a href="http://hdl.handle.net/20.500.14428/79183" style="color: inherit;" target="_blank">
                                    <img class="imgArque"
                                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img005.jpg">
                                </a>
                            </p>
                        </div>
                        <div class="col-sm-6 tab3">
                            <p class="text-center">
                                <a href="http://hdl.handle.net/20.500.14428/79188" style="color: inherit;" target="_blank">
                                    <img class="imgArque"
                                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img006.jpg">
                                </a>
                            </p>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 tab3">
                            <p class="text-center">
                                <a href="http://hdl.handle.net/20.500.14428/79161" style="color: inherit;" target="_blank">
                                    <img class="imgArque"
                                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img007.jpg">
                                </a>
                            </p>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 tab">
                            <iframe width="100%" height="475" src="https://www.youtube.com/embed/iiKu-CEwauY"
                                title="YouTube video player" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen></iframe>
                            <p class="text-center">
                                <span class="fontMS100Italic text-white">
                                    En el Museo de Arqueología y Antropología. Noticiarios Peruanos de la década
                                    de 1940. Película grabada en cintas de nitrato de 35 mm y digitalizada en la
                                    Biblioteca Digital BNP.
                                </span>
                            </p>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>
<div class="fondoMarron_L">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p>
                    <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoMarron">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;" class="fontMS700 colorPrincipal font-40">
                            LA ETNOHISTORIA ANDINA <br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio15/ET03_MS010_ANTIGUO_LINEA1-recortada2.png">
                    </div>
                </div>
                <p class="fontMS500 text-center text-white font-24">
                    <br><br><br>
                    PARA CONOCER LAS PARTICULARIDADES DE LA VIDA COTIDIANA DEL MUNDO ANDINO PREHISPÁNICO, SURGE LA
                    DISCIPLINA DE LA ETNOHISTORIA A MEDIADOS DEL SIGLO XX. LA ETNOHISTORIA ES EL ESTUDIO DEL PASADO A
                    TRAVÉS DE LAS TÉCNICAS DE LA ANTROPOLOGÍA CULTURAL.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-1">
                        <br>
                    </div>
                    <div class="col-sm-4">
                        <img width="100%" src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img013.jpg">
                        <p class="fontMS100Italic text-white">
                            Luis Eduardo Valcárcel acompañado de sus hijos Ada, Margot y Frank, 1929.

                        </p>
                    </div>
                    <div class="col-sm-7">
                        <p class="font-24 text-white">
                            Desde la Universidad Nacional Mayor de San Marcos y el Museo Nacional, figuras como Raúl
                            Porras Barrenechea y Luis E. Valcárcel impulsan la incorporación de nuevas fuentes y
                            herramientas interpretativas a la disciplina histórica. Se empieza a revisar con otros
                            enfoques los archivos nacionales, regionales y locales. Se examinan documentos previamente
                            ignorados, como las visitas coloniales, disputas legales y los expedientes de los
                            extirpadores de idolatrías. Los etnohistoriadores además corroboran sus interpretaciones con
                            estudios arqueológicos, lingüísticos y etnográficos. Poco a poco, empieza a surgir una
                            mirada más completa y más compleja del Antiguo Perú, la visión de un pasado pluriétnico,
                            pluricultural y plurilingüístico.
                            <br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4 mt-3 mb-3">
                        <a href="http://hdl.handle.net/20.500.14428/79613" style="color: inherit;" target="_blank">
                            <img width="100%"
                                src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img014.jpg">
                        </a>
                    </div>
                    <div class="col-sm-4 mt-3 mb-3">
                        <a href="http://hdl.handle.net/20.500.14428/79158" style="color: inherit;" target="_blank">
                            <img width="100%"
                                src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img015.jpg">
                        </a>
                    </div>
                    <div class="col-sm-4 mt-3 mb-3">
                        <a href="http://hdl.handle.net/20.500.14428/79157" style="color: inherit;" target="_blank">
                            <img width="100%"
                                src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img016.jpg">
                        </a>
                    </div>
                </div>
                <div class="row mt-5 mb-5">
                    <div class="col-sm-4 mb-3">
                        <img width="90%" class="imgtab"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img017.jpg">
                    </div>
                    <div class="col-sm-8 mt-3">
                        <p class="fontMS100 font-24 text-white">
                            <a href="http://hdl.handle.net/20.500.14428/79618" style="color: inherit; text-decoration: none;"
                                target="_blank">
                                <span class="fontMS700 textUpF">José María Arguedas.</span> <br>
                                <span class="fontMS100Italic">Puquio, una cultura en proceso de cambio. </span><br>
                                <span>Revista del Museo Nacional, no. 25, 1956.</span>
                            </a>
                            <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
                            <br>
                        </p>
                        <p class="fontMS100 font-24 text-white">
                            <a href="http://hdl.handle.net/20.500.14428/79617" style="color: inherit; text-decoration: none;"
                                target="_blank">
                                <span class="fontMS700 textUpF">María Rostworowski de Diez Canseco.</span> <br>
                                <span class="fontMS100Italic">Reflexiones sobre la reciprocidad andina.</span><br>
                                <span>Revista del Museo Nacional, no. 42, 1972.</span>
                            </a>
                            <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
                            <br>
                        </p>
                        <p class="fontMS100 font-24 text-white">
                            <a href="http://hdl.handle.net/20.500.14428/79620" style="color: inherit; text-decoration: none;"
                                target="_blank">
                                <span class="fontMS700 textUpF">Waldemar Espinoza Soriano.</span> <br>
                                <span class="fontMS100Italic">Las mujeres secundarias de Huayna Capac: dos casos de
                                    señorialismo feudal en el Imperio Inca.</span><br>
                                <span>Revista del Museo Nacional, no. 42, 1972.</span>
                            </a>
                            <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
                            <br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" width="100%">
                <p class="fontMS500 text-justify font-24">
                    <br>
                    LA ETNOHISTORIA NO DESESTIMA LAS VERSIONES OFICIALES DE LA HISTORIA; PERO MÁS LE ENCANTA LA
                    INFORMACIÓN SUMINISTRADA POR LOS PROPIOS GRUPOS ÉTNICOS; PORQUE SU ANHELO ES EXPLICAR LA HISTORIA
                    TAL COMO LA SENTÍAN, VIVÍAN Y COMPRENDÍAN. CLARO QUE TODO ELLO ESTÁ LIMITADO POR LA DISPOSICIÓN DE
                    LAS FUENTES, PESE A ESTO HA AVANZADO MUCHO. LO QUE ACABO DE EXPRESAR ES LA VISIÓN ANTROPOLÓGICA DE
                    LA HISTORIA DEL RUNA. EN OTRAS PALABRAS: DE LA ETNOHISTORIA, QUE COINCIDE CON LAS NUEVAS CORRIENTES
                    DE LAS CIENCIAS SOCIALES. PORQUE EL ETNOHISTORIADOR AUTÉNTICO PREGUNTA AL PASADO PREOCUPADO POR LOS
                    PROBLEMAS DEL PRESENTE.
                    <br>
                </p>
                <div class="text-right">
                    <p class="fontMS500Italic text-right font-24">
                        <br>
                        WALDEMAR ESPINOZA SORIANO, 1999.
                        <br>
                    </p>
                </div>
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio15/ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            ¿QUIÉNES SOMOS? <br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio15/ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS300 text-center colorPrincipal font-40">
                    APORTES DESDE LA ANTROPOLOGÍA
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br><br>
                    LA ANTROPOLOGÍA ES EL ESTUDIO DEL SER HUMANO Y SU CULTURA: SUS CREENCIAS, COSTUMBRES Y EXPRESIONES
                    ARTÍSTICAS. ENFATIZA LA INTERRELACIÓN ENTRE EL INDIVIDUO, LA COMUNIDAD, EL MEDIO AMBIENTE Y LOS
                    PROCESOS HISTÓRICOS. ESTA MIRADA HOLÍSTICA TRANSFORMA LAS CIENCIAS SOCIALES EN EL PERÚ, COMO SE
                    PUEDE APRECIAR EN LOS CASOS DE LA ARQUEOLOGÍA Y LA HISTORIA.
                    <br>
                </p>
                <p class="fontMS100 text-justify  font-24 text-gris">
                    <br>
                    Pero, ¿qué es lo que hacen los antropólogos? La fuente por excelencia de la antropología es el mismo
                    ser humano en sociedad. Para conocerlo, los antropólogos conviven con la comunidad que están
                    estudiando con el fin de realizar entrevistas, participar en su vida cotidiana y documentar sus
                    observaciones.
                    <br><br>
                    Históricamente, esta disciplina ha sufrido un sesgo colonial; es decir, un antropólogo supuestamente
                    civilizado es el encargado de interpretar y representar la cultura de una comunidad supuestamente
                    primitiva. En el Perú, la antropología forja otro camino. Los antropólogos peruanos documentan la
                    supervivencia de la cultura andina a lo largo del tiempo. No solo estudian la continuidad sino
                    también los procesos de cambio y las resignificaciones. Gracias a pioneros como Hildebrando Castro
                    Pozo, Efraín Morote y José María Arguedas, la antropología ya no es el estudio del Otro sino el
                    estudio de un nosotros heterogéneo.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-4 mt-3 mb-3">
                        <a href="https://hdl.handle.net/20.500.14428/43882" style="color: inherit;" target="_blank">
                            <img width="100%"
                                src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img018.jpg">
                        </a>
                    </div>
                    <div class="col-sm-4 mt-3 mb-3">
                        <a href="http://hdl.handle.net/20.500.14428/79159 " style="color: inherit;" target="_blank">
                            <img width="100%"
                                src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img019.jpg">
                        </a>
                    </div>
                    <div class="col-sm-4 mt-3 mb-3">
                        <a href="http://hdl.handle.net/20.500.14428/79249" style="color: inherit;" target="_blank">
                            <img width="100%"
                                src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img020.jpg">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-2">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel pb-3" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-8">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            EL PRIMER CONGRESO INTERNACIONAL <br>
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS300 text-center colorPrincipal font-40">
                    DE PERUANISTAS
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br>
                    CON EL MOTIVO DEL IV CENTENARIO DE FUNDACIÓN DE LA UNIVERSIDAD NACIONAL MAYOR DE SAN MARCOS, SE
                    CELEBRA EL PRIMER CONGRESO INTERNACIONAL DE PERUANISTAS EN 1951.
                    <br>
                </p>
                <p class="fontMS100 text-justify  font-24 text-gris">
                    <br>
                    Impulsado por el Instituto de Historia de dicha universidad, el congreso pretende crear un diálogo
                    interdisciplinario, convocando a todos los investigadores comprometidos con el estudio de la
                    cultura americana y el porvenir del continente. La temática abarca cinco líneas generales: historia
                    y geografía; etnología, arqueología, arte y folklore; derecho indiano; literatura, filología y
                    lingüística; y museología y archivología. Participaron en la organización del evento los
                    historiadores Ella Dunbar Temple, Raúl Porras Barrenechea y Alberto Tauro del Pino, el etnólogo
                    Paul Rivet y el antropólogo Luis E. Valcárcel, entre otros.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify  font-24 text-gris">
                            Dentro de la sección de Etnología y Folklore, José María Arguedas participa en el congreso
                            con una ponencia titulada "El arte popular religioso y la cultura mestiza en Huamanga", en
                            el
                            que recoge el testimonio del retablista Joaquín López Antay, a quien considera máximo
                            representante de la cultura mestiza. Arguedas critica lo que él consideraba una mirada
                            deshistorizante de la cultura indígena y reclama la falta de discusión sobre el sujeto
                            mestizo en el congreso.
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                    </div>
                    <div class="col-sm-4">

                        <!-- <a [routerLink]="['/ficha/LIB-915']" style="color: inherit;" target="_blank">
                            <img width="100%"
                                src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img022.jpg">
                        </a> -->

                        <div class="libro">
                            <a target="_blank" class="enlace" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79208">
                                <img class="img-fluid mb-3" width="100%"
                                    src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_img022.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        José María Arguedas. <br>
                                        El arte popular religioso y la cultura mestiza en Huamanga, 1950.

                                    </p>
                                </div>
                            </a>
                        </div>

                    </div>
                    <div class="col-sm-4">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoOrange">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-3">
                        <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS500 text-white font-40">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-9">
                        <img id="img_dialogo"
                            src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <p class="text-white text-justify font-24">
                    Después de conocer la obra de estos pensadores peruanos, te invitamos a reflexionar a partir de la
                    siguiente cita del antropólogo Carlos Iván Degregori (2000):
                    <br><br>
                    <span class="font-22">"En las etnografías clásicas descubrimos con frecuencia la tendencia a
                        construir a un Otro fuera de
                        la Historia, exotizándolo y esencializándolo, sea como el buen salvaje que debe ser protegido en
                        su
                        pureza o como el primitivo destinado a desaparecer [...] ¿Qué pasa cuando el Otro no está en una
                        isla lejana, una selva impenetrable o algún desierto calcinante, sino dentro del propio país,
                        literalmente a la vuelta de la esquina o incluso dentro del propio antropólogo? En otras
                        palabras,
                        ¿qué pasa cuando los Otros, antes objeto de estudio, se convierten ellos mismos en científicos
                        sociales?"</span>
                    <br>
                </p>
                <div class="row">
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            ¿Crees que persiste la exotización o la esencialización del Otro dentro del Perú? Explica tu
                            respuesta.

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            Te invitamos a comparar las trayectorias de Julio C. Tello y José María Arguedas. ¿De dónde
                            son? ¿Cómo se identificaban? ¿Cuál es el vínculo entre su lugar de procedencia y su
                            investigación científica?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            ¿Alguna vez has visitado un museo de arqueología? ¿Qué te pareció? ¿Qué nuevas cosas
                            aprendiste? ¿Encuentras vínculos con el antiguo Perú?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio15/ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio15/ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                </div>
                <p class="fontMS100 font-24">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Cortez, E. (2016). </span><br>
                            <span class="fontMS100Italic text-gris">José María Arguedas, etnógrafo: campo cultural y
                                mestizaje.
                            </span>
                            <span class="text-gris">En: LETRAS 87(125): 69-91.</span><br>
                            <a href="http://www.scielo.org.pe/pdf/letras/v87n125/a04v87n125.pdf" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Degregori, C. I. (2000). </span><br>
                            <span class="fontMS100Italic text-gris">No hay país más diverso. Compendio de antropología
                                peruana. </span>
                            <span class="text-gris">Lima: IEP.</span><br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=561755" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Espinoza Soriano, W. (1999). </span><br>
                            <span class="fontMS100Italic text-gris">La etnohistoria andina. </span>
                            <span class="text-gris">En: Investigaciones sociales 3(4): 123-132. </span><br>
                            <a href="https://centroderecursos.cultura.pe/sites/default/files/rb/pdf/La%20etnohistoria%20andina.pdf"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Huarcaya-Victoria, J. (2018).</span><br>
                            <span class="fontMS100Italic text-gris">La figura de Hermilio Valdizán Medrano en la
                                medicina peruana.
                            </span>
                            <span class="text-gris">En: Anales de la Facultad de Medicina 79(1): 75-82. </span><br>
                            <a href="https://dx.doi.org/10.15381/anales.v79i1.14597" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">López Lenci, Y. (2012). </span><br>
                            <span class="fontMS100Italic text-gris">Del sepulcro al germen: El Cuzco Paqarina como
                                tejido-partitura en cinco movimientos. El aporte de Luis E Valcárcel. </span>
                            <span class="text-gris">En: Letral (9): 35-61. </span><br>
                            <a href="https://dialnet.unirioja.es/servlet/articulo?codigo=5370501" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Lumbreras Salcedo, L.G. (2006). </span><br>
                            <span class="fontMS100Italic text-gris">Apuntes sobre Julio C. Tello, el Maestro.
                            </span>
                            <span class="text-gris">En: San Marcos (24): 209-222.</span><br>
                            <a href="https://sisbib.unmsm.edu.pe/bibvirtualdata/publicaciones/san_marcos/n24_2006/a10.pdf"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>